// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__TnsD9","disappear":"Preloader_disappear__Y-1eK","show":"Preloader_show__adntF","slideIn":"Preloader_slideIn__BN9Ov"};